const vLN508 = 50;
const v10240 = /\(error: (.*)\)/;
function f1605(...Iîíiîií) {
  const v10241 = Iîíiîií.sort((p12856, p12857) => p12856[0] - p12857[0]).map(p12858 => p12858[1]);
  return (p12859, p12860 = 0) => {
    const vA562 = [];
    for (const v10242 of p12859.split("\n").slice(p12860)) {
      if (v10242.length > 1024) {
        continue;
      }
      const v10243 = v10240.test(v10242) ? v10242.replace(v10240, "$1") : v10242;
      for (const v10244 of v10241) {
        const vV10244 = v10244(v10243);
        if (vV10244) {
          vA562.push(vV10244);
          break;
        }
      }
    }
    return f1607(vA562);
  };
}
function f1606(p12861) {
  if (Array.isArray(p12861)) {
    return f1605(...p12861);
  } else {
    return p12861;
  }
}
function f1607(p12862) {
  if (!p12862.length) {
    return [];
  }
  let vP12862 = p12862;
  const v10245 = vP12862[0].function || "";
  const v10246 = vP12862[vP12862.length - 1].function || "";
  if (v10245.indexOf("captureMessage") !== -1 || v10245.indexOf("captureException") !== -1) {
    vP12862 = vP12862.slice(1);
  }
  if (v10246.indexOf("sentryWrapped") !== -1) {
    vP12862 = vP12862.slice(0, -1);
  }
  return vP12862.slice(0, vLN508).map(p12863 => ({
    ...p12863,
    filename: p12863.filename || vP12862[0].filename,
    function: p12863.function || "?"
  })).reverse();
}
const vLSanonymous = "<anonymous>";
export function a(p12864) {
  try {
    if (p12864 && typeof p12864 == "function") {
      return p12864.name || vLSanonymous;
    } else {
      return vLSanonymous;
    }
  } catch (e94) {
    return vLSanonymous;
  }
}
function f1609(p12865) {
  const v10247 = /^\s*[-]{4,}$/;
  const v10248 = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
  return p12866 => {
    if (p12866.match(v10247)) {
      return {
        filename: p12866
      };
    }
    const v10249 = p12866.match(v10248);
    if (!v10249) {
      return;
    }
    let v10250;
    let v10251;
    let v10252;
    let v10253;
    let v10254;
    if (v10249[1]) {
      v10252 = v10249[1];
      let v10255 = v10252.lastIndexOf(".");
      if (v10252[v10255 - 1] === ".") {
        v10255--;
      }
      if (v10255 > 0) {
        v10250 = v10252.slice(0, v10255);
        v10251 = v10252.slice(v10255 + 1);
        const v10256 = v10250.indexOf(".Module");
        if (v10256 > 0) {
          v10252 = v10252.slice(v10256 + 1);
          v10250 = v10250.slice(0, v10256);
        }
      }
      v10253 = undefined;
    }
    if (v10251) {
      v10253 = v10250;
      v10254 = v10251;
    }
    if (v10251 === "<anonymous>") {
      v10254 = undefined;
      v10252 = undefined;
    }
    if (v10252 === undefined) {
      v10254 = v10254 || "<anonymous>";
      v10252 = v10253 ? v10253 + "." + v10254 : v10254;
    }
    const v10257 = v10249[2] && v10249[2].startsWith("file://") ? v10249[2].slice(7) : v10249[2];
    const v10258 = v10249[5] === "native";
    const v10259 = v10258 || v10257 && !v10257.startsWith("/") && !v10257.startsWith(".") && v10257.indexOf(":\\") !== 1;
    const v10260 = !v10259 && v10257 !== undefined && !v10257.includes("node_modules/");
    return {
      filename: v10257,
      module: p12865 ? p12865(v10257) : undefined,
      function: v10252,
      lineno: parseInt(v10249[3], 10) || undefined,
      colno: parseInt(v10249[4], 10) || undefined,
      in_app: v10260
    };
  };
}
function f1610(p12867) {
  return [90, f1609(p12867)];
}